import { render, staticRenderFns } from "./bulk-message-template-create-page.vue?vue&type=template&id=8592a214&scoped=true&"
import script from "./bulk-message-template-create-page.vue?vue&type=script&lang=js&"
export * from "./bulk-message-template-create-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8592a214",
  null
  
)

export default component.exports